interface IconProps {
	className?: string
	theme?: 'light' | 'dark'
}

export const DownloadIcon: React.FC<IconProps> = ({ className, theme= 'light' }) => {
	return (
		<svg
			className={className}
			viewBox="0 0 10 11"
			fill={theme === 'light' ? "#131313" : '#fff'}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill={theme === 'light' ? "#131313" : '#fff'}
				d="M5 7.83154L1.875 4.70654L2.75 3.80029L4.375 5.42529V0.331543H5.625V5.42529L7.25 3.80029L8.125 4.70654L5 7.83154ZM0 10.3315V7.20654H1.25V9.08154H8.75V7.20654H10V10.3315H0Z"
			/>
		</svg>

	)
}
